export const contactPersons: TableModule = {
    name: "contactPersons",
    route: "spa.userContacts",
    defaultOrder: {
        column: "lastname|firstname",
        direction: "asc"
    },
    columns: [
        {
            name: "customName",
            sortable: true,
            sortBy: "lastname|firstname",
            mobile: true,
        },
        {
            name: "function",
        },
        {
            name: "contact",
        }
    ],
    filters: [
        {
            name: 'contactType',
            column: 'customFilterContactType',
            type: 'select',
            options: [
                {
                    value: 'sportLeader',
                    label: 'contactPersons.contactTypes.sportLeader'
                }, {
                    value: 'sportAdmin',
                    label: 'contactPersons.contactTypes.sportAdmin'
                }, {
                    value: 'organisationResponsible',
                    label: 'contactPersons.contactTypes.organisationResponsible'
                }, {
                    value: 'teamResponsible',
                    label: 'contactPersons.contactTypes.teamResponsible'
                }, {
                    value: 'referee',
                    label: 'contactPersons.contactTypes.referee'
                }
            ],
            reduced: true
        }, {
            name: 'contest',
            column: 'contests.id',
            relation: 'contests',
            type: 'searchSelect',
            reduced: "in",
            spaRoute: 'spa.sportsManagement.contests.index',
            additionalDisplayKey: "game_class_name",
            searchThreshold: 1,
            searchSelectConfig: {
                fetchOnSearch: false,
            },
        }, {
            name: 'organisation',
            column: 'organisations.name',
            relation: 'userLinks.organisation',
            type: 'string',
            reduced: true,
        }, {
            name: 'team',
            column: 'teams.name',
            relation: 'userLinks.team',
            type: 'string',
            reduced: true,
        }
    ],
    quickFilters: [],
    tools: [
        {
            name: 'contactPersons.copyMultipleEmails',
            ability: ['viewAny', 'users']
        }
    ]
}